import * as utils from '@utils/form';
import { SLUG_RULE, TITLE_RULE } from '@constants';

// dev: 6182736a9405c0bfa259d784, qa: 61558dfed352a13729c1c4d7, uat: 611d2e56bd6eae9c48bbe243, prod: 614ae9002439b2b20670561f
export const KIDS_ATHLETICS = {
  name: 'Kids Athletics',
  id: ['6182736a9405c0bfa259d784', '61558dfed352a13729c1c4d7', '611d2e56bd6eae9c48bbe243', '614ae9002439b2b20670561f'],
};

export const FORM_FIELD = {
  PARENT_PAGE: {
    name: 'parentPage',
    label: 'Parent page:',
    serialize: utils.relatedEntitySerializerForContentId,
    deserialize: utils.makeRelatedEntityDeserializer(['id', 'title']),
    deserializeError: utils.deserializeErrorRelatedField,
  },
  PAGE_TYPE: {
    name: 'type',
    label: 'Page type:',
    rules: [{ required: true, message: 'Page type is required' }],
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.relatedEntityDeserializer,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  COMPETITION: {
    name: 'competition',
    label: 'For competition:',
    rules: [{ required: true, message: 'Competition is required' }],
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.relatedEntityDeserializer,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  EVENT: {
    name: 'event',
    label: 'For event:',
    rules: [{ required: true, message: 'Event is required' }],
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.relatedEntityDeserializer,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  TITLE: {
    name: 'title',
    label: 'Page title:',
    rules: [{ required: true, message: 'Title is required' }, TITLE_RULE],
  },
  SLUG: {
    name: 'slug',
    label: 'Slug:',
    rules: [{ required: true, message: 'Page slug is required' }, SLUG_RULE],
  },
  SEO_DESCRIPTION: {
    name: 'seoDescription',
    label: 'SEO description:',
    rules: [{ required: true, message: 'SEO description is required' }],
  },
  CONTENT_MODULES: {
    name: 'contentModules',
    preset: 'pages',
    deserializeError: utils.deserializeContentModulesErrors,
  },
  GATED_CONTENT: {
    name: 'gatedContent',
    label: 'Gated content',
  },
  NO_INDEX: {
    name: 'noIndex',
    label: 'No Index',
  },
  IS_ULTIMATE_DESIGN: {
    name: 'isUltimateDesign',
    label: 'Page uses ultimate design',
  },
  PAGE_LANGUAGE: {
    name: 'language',
    label: 'Language:',
  },
  CAMPAIGN: {
    name: 'campaign',
    label: 'Campaign',
    placeholder: 'Add new campaign',
    rules: [{ required: true, message: 'Campaign is required' }],
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.relatedEntityDeserializer,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  MINISITE: {
    name: 'site',
    label: 'For minisite:',
    rules: [{ required: true, message: 'Minisite is required' }],
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.relatedEntityDeserializer,
    deserializeError: utils.deserializeErrorRelatedField,
  },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);

export const FORM_VALUES_TO_WATCH = [
  FORM_FIELD.PAGE_TYPE.name,
  FORM_FIELD.PARENT_PAGE.name,
  FORM_FIELD.COMPETITION.name,
  FORM_FIELD.EVENT.name,
];

export const DEFAULT_VALUES = {
  [FORM_FIELD.CONTENT_MODULES.name]: [],
};
